import { createClient } from '@supabase/supabase-js'
import type { Database } from '@parchala/shared'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

// Siempre crear el cliente si las vars existen en el bundle actual
export const supabase =
  url && key
    ? createClient<Database>(url, key, {
        auth: {
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: true,
          storage: localStorage,
        },
        realtime: { params: { eventsPerSecond: 10 } },
      })
    : null

export const hasSupabase = supabase !== null

// Helper para usar en lugares que requieren Supabase
export function getSupabase() {
  if (!supabase) throw new Error('Supabase no disponible. Revisa .env.local')
  return supabase
}
